export default [
  {label: "Sole Proprietor", value: "Sole Proprietor"},
  {label: "Limited Liability Company (LLC)", value: "Limited Liability Company (LLC)"},
  {label: "Corporation", value: "Corporation"},
  {label: "Limited Partnership (LP)", value: "Limited Partnership (LP)"},
  {label: "Limited Liability Partnership (LLP)", value: "Limited Liability Partnership (LLP)"},
  {label: "General Partnership", value: "General Partnership"}
];
